import { createAction } from 'redux-actions';

export const fetchClient = createAction('FETCH_CLIENT');
export const fetchClientSuccess = createAction('FETCH_CLIENT_SUCCESS');
export const fetchClientFailure = createAction('FETCH_CLIENT_FAILURE');

export const createClient = createAction('CREATE_CLIENT');
export const createClientSuccess = createAction('CREATE_CLIENT_SUCCESS');
export const createClientFailure = createAction('CREATE_CLIENT_FAILURE');

export const updateClient = createAction('UPDATE_CLIENT');
export const updateClientSuccess = createAction('UPDATE_CLIENT_SUCCESS');
export const updateClientFailure = createAction('UPDATE_CLIENT_FAILURE');

export const deleteClient = createAction('DELETE_CLIENT');
export const deleteClientSuccess = createAction('DELETE_CLIENT_SUCCESS');
export const deleteClientFailure = createAction('DELETE_CLIENT_FAILURE');

export const createClientSecret = createAction('CREATE_CLIENT_SECRET', (clientId, secret) => ({clientId, secret}));
export const createClientSecretSuccess = createAction('CREATE_CLIENT_SECRET_SUCCESS');
export const createClientSecretFailure = createAction('CREATE_CLIENT_SECRET_FAILURE');

export const acceptClientSecret = createAction('ACCEPT_CLIENT_SECRET');

export function newClient() {
	const data = {
		enabled: false,
		protocolType: 'oidc',
		clientSecrets: [],
		requireClientSecret: true,
		clientName: '',
		description: '',
		clientUri: null,
		logoUri: null,
		requireConsent: false,
		allowRememberConsent: true,
		allowedGrantTypes: [],
		requirePkce: true,
		allowPlainTextPkce: false,
		allowAccessTokensViaBrowser: false,
		redirectUris: [],
		postLogoutRedirectUris: [],
		frontChannelLogoutUri: null,
		frontChannelLogoutSessionRequired: true,
		backChannelLogoutUri: null,
		backChannelLogoutSessionRequired: true,
		allowOfflineAccess: true,
		allowedScopes: [],
		alwaysIncludeUserClaimsInIdToken: false,
		identityTokenLifetime: 300,
		accessTokenLifetime: 3600,
		authorizationCodeLifetime: 300,
		absoluteRefreshTokenLifetime: 2592000,
		slidingRefreshTokenLifetime: 1296000,
		consentLifetime: null,
		refreshTokenUsage: 1,
		updateAccessTokenClaimsOnRefresh: false,
		refreshTokenExpiration: 1,
		accessTokenType: 0,
		enableLocalLogin: true,
		identityProviderRestrictions: [],
		includeJwtId: false,
		claims: [],
		alwaysSendClientClaims: false,
		clientClaimsPrefix: 'client_',
		pairWiseSubjectSalt: null,
		userSsoLifetime: null,
		userCodeType: null,
		deviceCodeLifetime: 300,
		allowedCorsOrigins: [],
		properties: {}
	};

	return {
		type: fetchClientSuccess,
		payload: data
	};
}
